<template>
  <Transition>
    <div class="skeleton-loader" :class="theme" v-if="showLoader">
      <div class="container">
        <div class="navbar">
          <div class="actions">
            <div class="action" v-for="tab in navigationTabs"
                 :key="tab">
            </div>
          </div>
          <div class="feedNavigation">
            <div class="navItem" v-for="tab in navigationTabs"
                 :key="tab">
            </div>
          </div>
        </div>
        <div class="feedTable">
          <div class="header">
            <div class="column"
                 :class="`column-${col}`"
                 v-for="col in columns"
                 :key="col">
            </div>
          </div>
          <div class="body">
            <div class="row" v-for="row in rows" :key="row">
              <div class="column avatar"></div>
              <div class="column column-1"></div>
              <div class="column column-2"></div>
              <div class="column column-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { themes } from '@/utility';

export default {
  name: 'SkeletonLoader',
  data() {
    return {
      showLoader: true,
      rows: 30,
      columns: 3,
      navigationTabs: 2,
      theme: '',
    };
  },
  methods: {
    setTheme() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      this.mapTheme(params.get('theme'));
    },
    mapTheme(theme) {
      this.theme = themes[theme];
    },
  },
  created() {
    this.setTheme();
  },
  mounted() {
    window.addEventListener('showSkeletonLoader', (message) => {
      const { showLoader } = message.detail;
      setTimeout(() => {
        this.showLoader = showLoader;
      }, 1000);
    });
  },
};
</script>

<style lang="scss">
.skeleton-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;

  .container {
    position: relative;
    height: 100vh;
    min-height: 500px;
    min-width: 230px;
    overflow: hidden;
    background-color: var(--bg);

    .navbar {
      padding: 8px 16px 0 16px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;

      .actions, .feedNavigation {
        width: 100%;
        display: flex;
        gap: 6px;

        .action {
          width: 50%;
          height: 30px;
          border-radius: var(--radius-48);
        }
      }

      .feedNavigation {
        .navItem {
          width: 50%;
          height: 30px;
          border-radius: var(--radius-4);
        }
      }
    }

    .feedTable {
      display: flex;
      flex-direction: column;
      gap: 7px;
      padding: 16px;
      height: calc(100% - 130px);

      .header {
        width: 100%;
        height: 10px;
        display: grid;
        grid-template-columns: 4fr 1fr 1fr;
        gap: 5px;
        justify-content: space-between;
        align-items: center;

        .column {
          height: 5px;
          border-radius: var(--radius-1);
        }
        .column-1 {
          width: 20px;
          margin-left: 40px;
        }
        .column-2 {
          width: 13px;
          justify-self: end;
        }
        .column-3 {
          width: 15px;
          justify-self: end;
        }
      }
      .body {
        width: 100%;
        height: 100%;
        display: flex;
        gap: 3px;
        flex-direction: column;

        .row {
          width: 100%;
          display: grid;
          grid-template-columns: 1fr 4fr 1fr 1fr;
          align-items: center;

          .column {
            height: 9px;
            border-radius: var(--radius-8);
          }
          .avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
          .column-1 {
            width: 80px;
          }
          .column-2, .column-3 {
            width: 30px
          }
          .column-3 {
            justify-self: end;
          }
        }
      }
    }
  }

  &.dark {
    background-color: rgb(44, 46, 48);

    .action, .navItem, .column {
      animation: pulse-bg-dark 1.5s infinite;
    }
  }
  &.light {
    background-color: rgba(244, 244, 244, 1);

    .action, .navItem, .column {
      animation: pulse-bg-light 1.5s infinite;
    }
  }
}

@keyframes pulse-bg-dark {
  0% {
    background-color: rgba(56, 56, 56, 1);
  }
  50% {
    background-color: rgba(76, 76, 76, 1);
  }
  100% {
    background-color: rgba(56, 56, 56, 1);
  }
}

@keyframes pulse-bg-light {
  0% {
    background-color: rgba(222, 222, 222, 1);
  }
  50% {
    background-color: rgba(234, 234, 234, 1);
  }
  100% {
    background-color: rgba(222, 222, 222, 1);
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
